module.exports = __webpack_public_path__ + "img/2.2e6c2352.png";